// UTILS
export const LOCAL_STORAGE_KEY = "session_auth";
// RUNSHEETS
export const DEFAULT_RUNSHEET = {
  externalId: "",
  name: "",
  scheduledAt: "",
  jobs: []
};
export const GENERATE_RUNSHEET = "GENERATE_RUNSHEET";
export const RUNSHEETS_LIST_FETCHED = "RUNSHEETS_LIST_FETCHED";
export const RUNSHEET_FETCHED = "RUNSHEET_FETCHED";
export const UPDATE_RUNSHEET = "UPDATE_RUNSHEET";
export const RUNSHEET_CANCELLED = "RUNSHEET_CANCELLED";
export const RUNSHEET_UPDATED = "RUNSHEET_UPDATED";
export const DUPLICATE_RUNSHEET = "DUPLICATE_RUNSHEET";
export const UPLOAD_RUNSHEET = "UPLOAD_RUNSHEET";
// JOBS
export const DEFAULT_JOB = {
  customerName: "",
  stop: { location: { name: "", type: { code: "" } } },
  notes: "",
  type: "",
  jobItems: []
};
export const JOBS_LIST_FETCHED = "JOBS_LIST_FETCHED";
export const JOB_UPDATED = "JOB_UPDATED";
export const JOB_SELECTED = "JOB_SELECTED";
export const ADD_JOB_ITEM = "ADD_JOB_ITEM";
export const REMOVE_JOB_ITEM = "REMOVE_JOB_ITEM";
export const UPDATE_JOB_ORDER = "UPDATE_JOB_ORDER";
export const ADD_JOB = "ADD_JOB";
export const UPDATE_JOB_SEQUENCE = "UPDATE_JOB_SEQUENCE";
export const JOB_ATTACHMENT_FETCHED = "JOB_ATTACHMENT_FETCHED";
// VEHICLES
export const VEHICLES_FETCHED = "VEHICLES_FETCHED";
// LOCATIONS
export const LOCATIONS_FETCHED = "LOCATIONS_FETCHED";
// USERS
export const USERS_FETCHED = "USERS_FETCHED";
export const ITEM_TYPES = "ITEM_TYPES";



// WEBPACK FOOTER //
// ./src/types.js